import { Text } from "@merge-api/merge-javascript-shared";
import { ArrowDown, ArrowUp } from "lucide-react";
import { calculateDeviation, normalizePercentage } from "./utils/helpers";

interface DeviationCellProps {
  currentData: number | null | undefined;
  baselineData: number | null | undefined;
}

const DeviationCell = ({ currentData, baselineData }: DeviationCellProps) => {
  if (currentData == null || baselineData == null) {
    return (
      <>
        <Text>-</Text> {/* Show dash if data is missing */}
      </>
    );
  }

  const isAboveBaseline = currentData > baselineData;
  const isBelowBaseline = currentData < baselineData;
  const deviation = calculateDeviation(currentData, baselineData);
  return (
    <>
      {/* This shouldn't occur with the current set of alerts, but setting this here for the future. */}
      {isAboveBaseline && <ArrowUp className="mr-1 w-4 h-4" />}
      {isBelowBaseline && <ArrowDown className="text-[#D61525] mr-1 w-4 h-4" />}
      <Text>{normalizePercentage(deviation ?? 0)}%</Text>
    </>
  );
};

export default DeviationCell;
